import type { StoreState } from '../../state-types';

/** Get all Answer Ids for a Card by cardId. Should be used with `useShallow` in React components */
export const getCardAnswerIds =
    (cardId: string) =>
    (state: StoreState): string[] => {
        const card = state.cards[cardId];
        return card && 'answerIds' in card ? card.answerIds : [];
    };
